var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stop)?_c('transition',[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"face"},[_c('div',{staticClass:"circle"})]),_vm._v(" "),_c('div',{staticClass:"face"},[_c('div',{staticClass:"circle"})])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29c3fcaa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/loading.vue
// module id = null
// module chunks = 